import moment from "moment";

export const handleDateFormat = (date, format) => {
  return moment(date).format(format);
  // const options = { year: "numeric", month: "short", day: "numeric" };
  // return new Date(moment(date)).toLocaleDateString("en-UK", options);
};
